import React from 'react';
import { ButtonGroup, Button } from 'react-bootstrap';
import "../../../assets/scss/buttongroup-toggle.scss";

export const ButtonGroupToggle = ({ options, value, onSelect, size, disabled = false, className }) => {
	size = (size || "sm");

	return (<ButtonGroup
		size={size}
		toggle={true}
		className={`btn-group-toggle-custom ${className || ""}`}>
		{options.map(item =>
			<Button
				key={item.value}
				disabled={disabled}
				variant={(item.value === value) ? "primary" : "default"}
				size={size}
				className={`${item.value === value ? "active" : "inactive"}`}
				onClick={e => {
					if (typeof onSelect === "function") onSelect(item.value, e);
				}}>
				{item.label}
			</Button>)}
	</ButtonGroup>);
};